import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

export default function PlayerList({ players, isLoading, onEdit, onDelete }) {
  const { isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="lg" text="Loading players..." />
      </div>
    );
  }

  if (!players || players.length === 0) {
    return (
      <div className="bg-white border border-gray-300 p-8 text-center mx-4">
        <p className="text-base font-semibold text-gray-900 mb-1">No players found</p>
        <p className="text-sm text-gray-600">
          Click "Add" to create your first player
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-300 mx-4">
      {/* Column Headers */}
      <div className="bg-gray-100 px-4 py-2 flex items-center gap-3 border-b border-gray-300">
        <div className="flex-1">
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-700">Name</span>
        </div>
        <div className="flex-shrink-0 text-center w-16">
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-700">HCP</span>
        </div>
        {isAuthenticated && (
          <div className="flex-shrink-0 w-24">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-700">Actions</span>
          </div>
        )}
      </div>

      {/* Player Rows */}
      <div>
        {players.map((player) => (
          <div
            key={player.id}
            className="flex items-center gap-3 px-4 py-3 border-b border-gray-200 last:border-b-0"
          >
            <div className="flex-1 min-w-0">
              <div className="text-base text-gray-900">
                {player.name}
              </div>
            </div>

            <div className="flex-shrink-0 text-center w-16">
              <div className="text-base font-semibold text-gray-900">
                {player.handicap}
              </div>
            </div>

            {isAuthenticated && (
              <div className="flex-shrink-0 w-24 flex gap-3 text-sm">
                <button
                  onClick={() => onEdit(player)}
                  className="text-primary hover:underline"
                >
                  Edit
                </button>
                <button
                  onClick={() => onDelete(player)}
                  className="text-gray-600 hover:text-gray-900 hover:underline"
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
